import { defineComponent as _defineComponent } from 'vue'
import store from '@/store';
import {
  dispatchGetCompanyPasswordSetting,
  dispatchUpdateCompanyPasswordSetting,
} from '@/store/main/actionsMain';
import PasswordSettingTable from '@/views/pages/passwordSetting/PasswordSettingTable.vue';
import { onMounted, ref, computed } from 'vue';
import sharedMessages from '@/lib/shared-messages';
import { PasswordLongevity } from '@/lib/enum/PasswordLongeviy';
import { defineMessages } from '@/lib/i18n';
import { usePermissionComposable } from '@/composables/usePermission';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordSettingPage',
  setup(__props) {

const { hasPermission, PERMISSIONS: P } = usePermissionComposable();
const canEditPasswordPolicy = computed(() =>
  hasPermission(P.PASSWORD_POLICY_EDIT)
);

/**
 * we input dummy value temporaily
 */
const minimumPasswordLength = ref<number>(12);
const passwordLongevity = ref<number>(PasswordLongevity.UNLIMITED);
const isLoading = ref<boolean>(true);
const isSaving = ref<boolean>(false);

const m = defineMessages({
  passwordSettingNotice: 'パスワードポリシー設定時の注意事項',
  noticeItem1:
    'パスワードポリシーの変更はユーザーに対してパスワードのリセットを強制させる場合があるため、慎重にかつ計画的に行ってください。',
});

onMounted(async () => {
  if (store.state.main.company !== null) {
    const response = await dispatchGetCompanyPasswordSetting(store, {
      companyId: store.state.main.company.uuid,
    });

    minimumPasswordLength.value = response.data.password_minimum_length;
    passwordLongevity.value = response.data.password_longevity;
    isLoading.value = false;
  }
});

const submit = async () => {
  if (!canEditPasswordPolicy.value || isSaving.value) {
    return;
  }
  if (store.state.main.company !== null) {
    isSaving.value = true;
    try {
      await dispatchUpdateCompanyPasswordSetting(store, {
        companyId: store.state.main.company.uuid,
        data: {
          password_minimum_length: minimumPasswordLength.value,
          password_longevity: passwordLongevity.value,
        },
      });
    } finally {
      isSaving.value = false;
    }
  }
};

return { __sfc: true,hasPermission, P, canEditPasswordPolicy, minimumPasswordLength, passwordLongevity, isLoading, isSaving, m, submit, PasswordSettingTable, sharedMessages }
}

})